export function isShallowEqual(v, o) {
  if (v === undefined && o !== undefined) return false;
  if (v !== undefined && o === undefined) return false;
  for (var key in v) if (!(key in o) || v[key] !== o[key]) return false;
  for (var key in o) if (!(key in v) || v[key] !== o[key]) return false;

  return true;
}

export function arraysEqual(array1: any[], array2: any[], key = 'id') {
  return (
    array1.every(item1 => array2.some(item2 => item1[key] == item2[key])) &&
    array2.every(item2 => array1.some(item1 => item1[key] == item2[key]))
  );
}

export function calculateDaysDiff(date1, date2) {
  if (!date1 || !date2) return;
  const d1 = new Date(date1).getTime();
  const d2 = new Date(date2).getTime();
  const diffTime = d2 - d1;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}
